import { Field, Item } from '@sitecore-jss/sitecore-jss-nextjs';

import { ExtendedItem } from 'src/types/ExtendedItem';

export function parseAccessTypes(field: Field | Item | Item[] | undefined): Map<string, string> | null {
	if (!field) {
		return null;
	}

	const accessTypes = new Map<string, string>();
	try {
		(field as Item[]).map((access: ExtendedItem) => {
			accessTypes.set(access.id, (access.fields.Title as Field<string>).value);
		});
	} catch (error) {
		console.error(error);
		return null;
	}
	if (accessTypes.size < 1) {
		return null;
	}

	return accessTypes;
}

export function parseAccessTypesString(field: Field | Item | Item[] | undefined): string {
	const accessTypes: string[] = [];
	try {
		(field as Item[]).map((access: ExtendedItem) => {
			accessTypes.push((access.fields.Title as Field<string>).value);
		});
	} catch (error) {
		console.error(error);
		return '';
	}
	if (accessTypes.length < 1) {
		return '';
	}

	return accessTypes.join(', ');
}
